export default "__VITE_ASSET__B49PRZ0O__"